<div class="agents-container">
  <div class="filters">
    <div class="search-filter-group">
      <!-- Search Box -->


      <!-- Filter Button -->
      <!-- TODO: Uncomment when filter is implemented -->
      <!-- <div class="filter-button-group">
        <button class="action-button" style="cursor: not-allowed">
          <div class="action-button-icon">
            <img src="assets/icones/filter_icon.svg" alt="" />
          </div>
          <span class="action-button-text">{{
            "common.filter" | translate
          }}</span>
        </button>
      </div> -->
      <div class="search-actions">
        <div class="search-filter-group">
          <!-- Search Box -->
          <div class="standard-input has-icon search-box">
            <div class="input-container">
              <input type="text"
                  placeholder="{{ 'agent.listing.search' | translate }}"
                  [formControl]="searchInput"
                  />
              <span class="btn-icon" style="cursor: default;">
                <app-svg-icon svgIcon="search_icon"></app-svg-icon>
              </span>
            </div>
          </div>

          <!-- Filter Button -->
          <div class="filter-button-group">
            <button class="action-button" (click)="setFilter()" [ngClass]="{ activeFilter: hasModuleFilters() }">
              <div class="action-button-icon">
                <img src="assets/icones/filter_icon.svg" alt="" />
              </div>
              <span class="action-button-text">{{ "common.filter" | translate }}</span>
              <div class="clear-icon-container">
                <img
                  class="clear-icon"
                  *ngIf="hasModuleFilters()"
                  (click)="clearFilter(); $event.stopPropagation()"
                  src="assets/icones/clear-icon.svg"
                  alt=""
                />
                <div class="clear-tooltip" *ngIf="hasModuleFilters()">
                  {{ "common.clear_filters" | translate }}
                </div>
              </div>
            </button>
          </div>

          <!-- Download Button -->
          <!-- <button class="action-button" (click)="exportQuotations()">
            <div class="action-button-icon">
              <img src="../../../../../assets/icones/download_icon.svg" alt="" />
            </div>
            <span class="action-button-text">{{ "quotations_and_orders.download" | translate }}</span>
          </button> -->
        </div>
      </div>

      <!-- Download Button -->
      <button class="action-btn secondary-btn" (click)="download()">
        <div class="icon">
          <img src="assets/icones/download_icon.svg" alt="" />
        </div>
        <span>
          {{ "agent.actions.download" | translate }}
        </span>
      </button>

      <!-- Delete Button -->
      <button
        *ngIf="selectedAgents.length"
        class="action-btn secondary-btn"
        style="border-color: #970000; color: #970000;"
        (click)="deleteConfirmation()"
      >
        <app-svg-icon svgIcon="trash-cc"></app-svg-icon>
      </button>

      <!-- New Agent Button -->
      <button
        style="margin-left: auto"
        class="action-btn primary-btn"
        (click)="newAgent()"
      >
        <span class="icon">
          <app-svg-icon svgIcon="plus-cc"></app-svg-icon>
        </span>
        <span> {{ 'agent.actions.create_agent' | translate }} </span>
      </button>
    </div>
  </div>
  <div class="agents-content">
    <table class="agents-table">
      <thead>
        <tr
          class="row header"
          style="padding-top: 10px; border: unset; height: unset"
        >
          <th>
            <mat-checkbox
              [checked]="isAllAgentsSelected()"
              [indeterminate]="isPartialSelectedAll()"
              (change)="toggleAllAgents($event.checked)"
            >
            </mat-checkbox>
            <div
              style="display: flex; flex-direction: row; align-items: center"
            >
              {{ "agent.listing.fullname" | translate }}
              <div class="sort-actions">
                <span
                  class="arrow-up"
                  [class.active]="
                    activeSortMode == 'asc' && activeSortKey == 'fullname'
                  "
                  (click)="sortByKey('fullname', 'asc')"
                ></span>
                <span
                  class="arrow-down"
                  [class.active]="
                    activeSortMode == 'desc' && activeSortKey == 'fullname'
                  "
                  (click)="sortByKey('fullname', 'desc')"
                ></span>
              </div>
            </div>
          </th>
          <th>{{ "agent.listing.tags" | translate }}</th>
          <th style="display: flex; flex-direction: row; align-items: center">
            {{ "agent.listing.portfolio" | translate }}
            <div class="sort-actions">
              <span
                class="arrow-up"
                [class.active]="
                  activeSortMode == 'asc' && activeSortKey == 'nbr_companies'
                "
                (click)="sortByKey('nbr_companies', 'asc')"
              ></span>
              <span
                class="arrow-down"
                [class.active]="
                  activeSortMode == 'desc' && activeSortKey == 'nbr_companies'
                "
                (click)="sortByKey('nbr_companies', 'desc')"
              ></span>
            </div>
          </th>
          <th style="display: flex; flex-direction: row; align-items: center">
            {{ "agent.listing.orders" | translate }}
            <div class="sort-actions">
              <span
                class="arrow-up"
                [class.active]="
                  activeSortMode == 'asc' && activeSortKey == 'order_count'
                "
                (click)="sortByKey('order_count', 'asc')"
              ></span>
              <span
                class="arrow-down"
                [class.active]="
                  activeSortMode == 'desc' && activeSortKey == 'order_count'
                "
                (click)="sortByKey('order_count', 'desc')"
              ></span>
            </div>
          </th>
          <th style="display: flex; flex-direction: row; align-items: center">
            {{ "agent.listing.total_orders" | translate }}
            <div class="sort-actions">
              <span
                class="arrow-up"
                [class.active]="
                  activeSortMode == 'asc' && activeSortKey == 'total_amount'
                "
                (click)="sortByKey('total_amount', 'asc')"
              ></span>
              <span
                class="arrow-down"
                [class.active]="
                  activeSortMode == 'desc' && activeSortKey == 'total_amount'
                "
                (click)="sortByKey('total_amount', 'desc')"
              ></span>
            </div>
          </th>
          <!-- <th>
            {{ "agent.listing.commissions" | translate }}
          </th>
          <th>{{ "agent.listing.performance" | translate }}</th> -->
          <th
            style="
              display: flex;
              flex-direction: row;
              align-items: center;
              justify-content: start !important;
            "
          >
            {{ "agent.listing.last_order" | translate }}
            <div class="sort-actions">
              <span
                class="arrow-up"
                [class.active]="
                  activeSortMode == 'asc' && activeSortKey == 'last_order_date'
                "
                (click)="sortByKey('last_order_date', 'asc')"
              ></span>
              <span
                class="arrow-down"
                [class.active]="
                  activeSortMode == 'desc' && activeSortKey == 'last_order_date'
                "
                (click)="sortByKey('last_order_date', 'desc')"
              ></span>
            </div>
          </th>
        </tr>
        <tr class="row header" style="padding-bottom: 10px; height: unset">
          <th></th>
          <th></th>
          <th>
            <span style="font-weight: 400" class="secondary-text">
              {{ "agent.listing.companies_nbr" | translate }}
            </span>
          </th>
          <th></th>
          <!-- <th></th>
          <th></th> -->
          <th>
            <!-- <span style="font-weight: 400" class="secondary-text">
              {{ "agent.listing.target" | translate }}
            </span> -->
          </th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <cdk-virtual-scroll-viewport itemSize="50" class="agents-viewport">
          <ng-container
            *cdkVirtualFor="
              let agent of filteredAgents;
              trackBy: trackByAgentId
            "
          >
            <tr class="row" (click)="goToDetails(agent)">
              <!-- Agent's fullname -->
              <td>
                <mat-checkbox
                  [disableRipple]="true"
                  [checked]="selectedAgents.includes(agent.id!)"
                  (change)="toggleAgent(agent.id!, $event.checked)"
                  (click)="$event.stopPropagation()"
                ></mat-checkbox>
                <span
                  class="truncate"
                  style="width: 200px"
                  [title]="agent.first_name + ' ' + agent.last_name"
                >
                  {{ agent.first_name + " " + agent.last_name }}
                </span>
              </td>
              <!-- Agent's tags -->
              <td>
                <div style="display: flex; gap: 5px">
                  <span
                    class="tag truncate"
                    *ngFor="let tag of agent.tags.slice(0, 2)"
                    [style.background-color]="tag.color"
                    [title]="tag.name"
                  >
                    {{ tag.name }}
                  </span>
                  <span
                    class="tag truncate"
                    *ngIf="agent.tags.length > 2"
                    style="color: #232529"
                  >
                    +{{ agent.tags.length - 2 }} more
                  </span>
                </div>
              </td>
              <!-- Agent's assigned locations count -->
              <td>
                {{ agent.nbr_companies }}
              </td>
              <!-- Agent's orders count -->
              <td>
                {{ agent.order_count }}
              </td>
              <!-- Agent's total orders amount in euros -->
              <td [style]="agent.total_amount ? 'text-align: right;' : ''">
                {{
                  agent.total_amount
                    ? agent.total_amount.toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                      }) + " €"
                    : "--"
                }}
              </td>
              <!-- Agent's commissions gains -->
              <!-- <td>
                {{ "--" }}
              </td> -->
              <!-- Agent's performance -->
              <!-- <td>
                {{ "--" }}
              </td> -->
              <!-- Agent's last order date -->
              <td>
                <span style="padding-left: 5px">{{
                  (agent.last_order_date | date : DATE_FORMAT) || "--"
                }}</span>
              </td>
            </tr>
          </ng-container>
          <ng-container *ngIf="!agents.length">
            <div
              style="
                height: 200px;
                display: flex;
                align-items: center;
                justify-content: center;
              "
              class="secondary-text"
            >
              {{ "agent.listing.no_data" | translate }}
            </div>
          </ng-container>
        </cdk-virtual-scroll-viewport>
      </tbody>
    </table>
  </div>
</div>
